import React from 'react';
import {
    Persona as RawPersona,
    PersonaStrokeColor,
} from '../../../components/landingPage/Persona';
import { SanityObject } from '../../../lib/landingPage';
import { ButtonLink, ButtonLinkProps } from '../Link';
import { ImageProps, Image } from '../Image';
import { Wrapper } from '../Wrapper';
import { observer } from 'mobx-react-lite';

export type PersonaMediaProps = {
    image: SanityObject<ImageProps>;
    topText?: string;
    bottomText?: string;
    strokeColor?: PersonaStrokeColor;
};

export type PersonaProps = {
    link: SanityObject<ButtonLinkProps>;
    title: string;
    description: string;
    reversed: boolean;
} & PersonaMediaProps;

const PersonaInternal = observer((props: PersonaProps) => {
    return (
        <RawPersona
            link={<ButtonLink value={props.link} />}
            title={props.title}
            reversed={props.reversed}
            image={<Image value={props.image} />}
            stroke={props.strokeColor}>
            {props.description}
        </RawPersona>
    );
});

export const Persona = Wrapper((props: PersonaProps): JSX.Element => {
    return <PersonaInternal {...props} />;
}, 'persona');
